import { useState } from "react";
import { X, Upload, ChevronLeft, ChevronRight } from "lucide-react";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

// Gallery upload editor (admin news form) + lightbox viewer
export function GalleryUploader({ images, onChange }) {
  const [uploading, setUploading] = useState(false);
  const upload = async (e) => {
    const files = Array.from(e.target.files || []); if (!files.length) return;
    setUploading(true);
    try {
      const urls = [];
      for (const f of files) {
        const fd = new FormData(); fd.append("file", f);
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        urls.push(`${process.env.REACT_APP_BACKEND_URL}${data.url}`);
      }
      onChange([...(images || []), ...urls]);
      toast.success(`${urls.length} तस्वीरें अपलोड हुईं`);
    } catch (err) { toast.error(formatError(err)); }
    finally { setUploading(false); e.target.value = ""; }
  };
  const remove = (i) => onChange(images.filter((_, idx) => idx !== i));

  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-3">
        {(images || []).map((u, i) => (
          <div key={u} className="relative w-24 h-24 border rounded overflow-hidden group">
            <img src={u} alt="" className="w-full h-full object-cover"/>
            <button type="button" onClick={() => remove(i)} className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-0.5 opacity-0 group-hover:opacity-100">
              <X className="w-3 h-3"/>
            </button>
          </div>
        ))}
      </div>
      <label className="cursor-pointer inline-flex items-center gap-2 border border-slate-300 rounded-md px-3 py-2 text-sm hover:bg-slate-50">
        <Upload className="w-4 h-4"/>{uploading ? "अपलोड हो रहा…" : "गैलरी तस्वीरें जोड़ें (multi-select)"}
        <input type="file" accept="image/*" multiple className="hidden" onChange={upload} data-testid="gallery-upload"/>
      </label>
    </div>
  );
}

export function GalleryViewer({ images }) {
  const [open, setOpen] = useState(false);
  const [idx, setIdx] = useState(0);
  if (!images || images.length === 0) return null;

  const openAt = (i) => { setIdx(i); setOpen(true); };
  const prev = () => setIdx((i) => (i - 1 + images.length) % images.length);
  const next = () => setIdx((i) => (i + 1) % images.length);

  return (
    <>
      <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 gap-2" data-testid="gallery-thumbs">
        {images.map((u, i) => (
          <button key={u} onClick={() => openAt(i)} className="aspect-video overflow-hidden rounded-md bg-slate-100">
            <img src={u} alt="" className="w-full h-full object-cover hover:scale-105 transition"/>
          </button>
        ))}
      </div>
      {open && (
        <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center" onClick={() => setOpen(false)} data-testid="gallery-lightbox">
          <button onClick={(e) => { e.stopPropagation(); setOpen(false); }} className="absolute top-4 right-4 text-white p-2 hover:bg-white/10 rounded" data-testid="gallery-close"><X className="w-6 h-6"/></button>
          <button onClick={(e) => { e.stopPropagation(); prev(); }} className="absolute left-4 text-white p-2 hover:bg-white/10 rounded"><ChevronLeft className="w-8 h-8"/></button>
          <img src={images[idx]} alt="" className="max-w-[90vw] max-h-[85vh] object-contain" onClick={(e) => e.stopPropagation()}/>
          <button onClick={(e) => { e.stopPropagation(); next(); }} className="absolute right-4 text-white p-2 hover:bg-white/10 rounded"><ChevronRight className="w-8 h-8"/></button>
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white text-sm bg-black/50 rounded-full px-4 py-1">{idx + 1} / {images.length}</div>
        </div>
      )}
    </>
  );
}
